import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Button.scss';

const Button  = ({buttonType, buttonStyle, buttonText, icon, children, ...rest}) => {
    const buttonClassMap = {
        style: {
            'Standard': 'style-standard',
            'Plain': 'style-plain'
        },
        type: {
            'Primary': 'type-primary',
            'Secondary': 'type-secondary',
            // ... add other types as needed
        }
    };
    const typeClass = buttonClassMap.type[buttonType];
    const styleClass = buttonClassMap.style[buttonStyle];
    return (
        <button type='button' className={`${typeClass || ''} ${styleClass || ''}`} {...rest}>
            {icon && <FontAwesomeIcon className='icon' icon={icon} ></FontAwesomeIcon>} 
            {buttonText && <span className='text'>{buttonText}</span>}
            {children}
        </button>
    );
}

export default Button;